export default "__VITE_ASSET__BLgWK5SQ__"